import { connect } from 'react-redux'
import ConnectedPageSearch from 'pages/search/ConnectedPageSearch'

import { selectSmartSearchEnabled } from 'redux/selectors/selectSmartSearchEnabled'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  searchType: state.search.searchType,
  searchPhrase: state.search.searchPhrase,
  pageNumber: state.search.pageNumber,
  pageLimit: state.search.pageLimit,
  query: state.search.query,
  smartSearchEnabled: selectSmartSearchEnabled(state)
})

export default connect(mapStateToProps, null)(ConnectedPageSearch)
